/*  ========================================================================
    # Components - Numeric Input
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import bem from '../../utils/bem';
import useLocalization from '../../hooks/useLocalization';
import useTranslation from '../../hooks/useTranslation';

const NumericInput = ({ currentValue, onValueChanged, min = 0, max = 999, label, name }) => {
  const local = useLocalization();
  const __ = useTranslation();
  return (
    <div className='c-numeric-input'>
      <label htmlFor={`numeric-input-${name}`} className='c-numeric-input__label'>
        {label}
      </label>
      <div className='c-numeric-input__fieldset'>
        <button
          className={bem('c-numeric-input', 'step', { minus: true }, [
            'c-button',
            'c-button--icon',
            'c-button--small',
            currentValue <= min ? 'c-button--disabled' : ''
          ])}
          disabled={currentValue <= min}
          onClick={() => onValueChanged(currentValue > min ? currentValue - 1 : min)}
          title={__('decrease')}
        >
          <svg viewBox='0 0 12 12' title={__('decrease')}>
            <use title={__('decrease')} href={`${local('svgSprite')}#minus`} />
          </svg>
        </button>
        <input
          type='text'
          className='c-numeric-input__input'
          min={min || 0}
          max={max || 999}
          step={1}
          id={`numeric-input-${name}`}
          name={name}
          value={currentValue}
          readOnly
          aria-disabled='true'
          tabIndex={-1}
          onChange={e => onValueChanged(parseInt(e.target.value, 10))}
        />
        <button
          className={bem('c-numeric-input', 'step', { plus: true }, [
            'c-button',
            'c-button--icon',
            'c-button--small',
            currentValue >= max ? 'c-button--disabled' : ''
          ])}
          disabled={currentValue >= max}
          onClick={() => onValueChanged(currentValue < max ? currentValue + 1 : max)}
          title={__('increase')}
        >
          <svg viewBox='0 0 12 12' title={__('increase')}>
            <use title={__('increase')} href={`${local('svgSprite')}#plus`} />
          </svg>
        </button>
      </div>
    </div>
  );
};

NumericInput.propTypes = {
  currentValue: PropTypes.number.isRequired,
  onValueChanged: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default NumericInput;
